module.exports = __webpack_public_path__ + "static/media/KevinVora1.d9b6d6e6.png";